/**
 * Plugin context for accessing plugin features
 */

import React, { createContext, useContext, ReactNode } from 'react';
import { pluginRegistry } from './PluginRegistry';

interface PluginContextType {
  getEntityHandler: (entityType: string) => any | null;
  getVisualizationProvider: (vizId: string) => any | null;
  getAllPlugins: () => any[];
}

const PluginContext = createContext<PluginContextType | null>(null);

export function PluginContextProvider({ children }: { children: ReactNode }) {
  const value: PluginContextType = {
    getEntityHandler: (entityType) => pluginRegistry.getEntityHandler(entityType),
    getVisualizationProvider: (vizId) => pluginRegistry.getVisualizationProvider(vizId),
    getAllPlugins: () => pluginRegistry.getAllPlugins(),
  };

  return <PluginContext.Provider value={value}>{children}</PluginContext.Provider>;
}

export function usePluginContext() {
  const context = useContext(PluginContext);
  if (!context) {
    throw new Error('usePluginContext must be used within PluginContextProvider');
  }
  return context;
}


